export class MockDiscordSDK {
  commands = {
    authorize(_: any) {
      return {
        code: "fakeAccessCode",
      };
    },
  };

  ready() {
    return;
  }

  instanceId = "fakeInstanceId";
}
